
import { PropsWithChildren } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import styled from "styled-components";
import { GRAY, LIGHT_GRAY, NEAR_WHITE } from "../../config";
import { translate } from "../../intl";
import { BaseField, BaseFieldProps } from "./BaseField";

export const Input = styled.input`
  width: 100%;
  padding: 9px 15px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid ${LIGHT_GRAY};
  background-color: ${GRAY};
  color: ${NEAR_WHITE};
  font-size: 14px;
  transition: 0.2s ease;
  outline: none;

  ::placeholder {
    color: ${NEAR_WHITE};
  }

  &:focus {
    border-color: ${LIGHT_GRAY};

    & + svg {
      color: ${LIGHT_GRAY};
    }
  }

  &:disabled {
    border: 0px;
    padding: 0px;
  }
`;

interface TextFieldProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends BaseFieldProps<TFieldValues, TName> {
  placeholder?: string;
}

export function TextField<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  name,
  label,
  placeholder,
  defaultValue,
  rules,
  form,
  readOnly,
  fieldClassName,
}: PropsWithChildren<TextFieldProps<TFieldValues, TName>>) {
  return (
    <BaseField
      form={form}
      name={name}
      label={label}
      defaultValue={defaultValue ?? ""}
      rules={rules}
      fieldClassName={`text-field ${fieldClassName}`}
      readOnly={readOnly}
      render={({ field }) => (
        <Input
          name={name}
          disabled={readOnly}
          onChange={field.onChange}
          value={field.value}
          placeholder={placeholder ?? translate("generic.typeHere")}
        />
      )}
    />
  );
}

TextField.defaultProps = {
  defaultValue: "",
};
